module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select-exchange":"Select Exchange","exchange-dfm":"DFM","exchange-nasdaq":"Nasdaq Dubai"},"ar":{"select-exchange":"حدد صرف","exchange-dfm":"سوق دبي المالي","exchange-nasdaq":"ناسداك دبي"}}')
  delete Component.options._Ctor
}
